<template>
	<div class="pages">
		<div class="pricing-list" style="margin: 0">
			<div class="totle">共计<span>{{pricingList.length}}</span>条</div>
			<div class="pricing-item" v-for="(item,index) in pricingList" :key="index" @click="click(item.Url)">
				<div class="title">一手项目达结佣阶段发函/诉讼预警表-营业部填写</div>
				<div class="applicant-time clearfix">
					<div class="applicant">项目名称：{{item.ProjectName}}</div>
					<div class="time">{{item.CreateTime}}</div>
				</div>
				<div class="label waiting-pricing">待填写</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
    firstHandAgency
	} from '@/api/firstHand'
	
	import {
		formatDate
	} from '@/utils/date.js'
	export default {
		data() {
			return {
				logInfo:{},
				serchForm: {},
				options: [],
				pricingList:[],
				names:{},
				datas:[]
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.load();
		},
		mounted() {
			
		},
		methods: {
			load(){
				let that = this;
				let {EmpNo} = that.logInfo
        firstHandAgency(EmpNo).then(res => {
          console.log(res.Body)
          that.pricingList = res.Body
        })
			},
			click(url){
				this.$router.push(url);
			},
			remote(value){
				if(value==null||value.trim()==''){
					this.options = [];
				}else{
					var array = [];
					array = Object.keys(this.names).map(val => ({
					        key: val,
					        val: this.names[val]
					    }))
					var option = [];
					array.forEach(e =>{
						if(e.key.indexOf(value)>-1){
							option.push({label:e.key,value:e.key})
						}
					})
					this.options = option;
				}
			},
			renderTime(date) {
			  // var dateee = new Date(date).toJSON();
			  return formatDate(date,"yyyy-MM-dd HH:mm:ss")
			}
		}
	}
</script>

<style lang="less">
	
	.serch-form {
		background: #fff;
		padding: 10px;
		position: fixed;
		left: 0;
		top: 0;
		opacity: 1;
		z-index: 6;
		width: 100%;

		.el-form-item {
			margin-bottom: 0px;
		}
	}
	.pricing-list{
		padding: 10px;
		.totle{
      font-size: 12px;
      //font-size: 15px;
      //text-align: center;
      //width: 100%;
      //height: 30px;
			span{
				color: #FF4346;
				padding: 0 4px;
			}
		}
		.pricing-item{
			width: 100%;
			background: #FFFFFF;
			position: relative;
			padding: 8px;
			margin-top: 10px;
			border-radius: 6px;
			box-shadow: 6px 6px 6px #CCCCCC;
			.title{
				font-size: 13px;
				color: #585354;
				line-height: 1.8;
				width: calc(100% - 40px);
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				padding-bottom: 4px;
			}
			.applicant-time{
				color: #585354;
				font-size: 12px;
				line-height: 1.7;
				div.applicant{
					width: 60%;
					float: left;
				}
				div.time{
					width: 40%;
					float: right;
					text-align: right;
				}
			}
			.label{
				position: absolute;
				right: 5px;
				top: 10px;
			}
			.waiting-pricing{
				color: #3FC243;
			}
			.waiting-check{
				color: #55ACEE;
			}
		}
		.pricing-item:first-child{
			margin-top: 0;
		}
	}
</style>
